import React from "react";
import styles from "./HomeBottom.module.css";
import { RiPhoneLine } from "react-icons/ri";
import { HiOutlineMail } from "react-icons/hi";
import { IoLocationOutline } from "react-icons/io5";
import HomeBottomLast from "./HomeBottomLast";

export default function HomeBottom() {
  const details = [
    {
      name: "Phone Number",
      icon: <RiPhoneLine size={22} color="#ffffff" />,
      data: "01-23456789",
    },
    {
      name: "Email",
      icon: <HiOutlineMail size={22} color="#ffffff" />,
      data: "Hello@visapro.ng",
    },
    {
      name: "Map Street",
      icon: <IoLocationOutline size={22} color="#ffffff" />,
      data: "Lekki Phase 1 - Lagos",
    },
  ];

  return (
    <div>
      <div className={styles.bottom}>
        <div className={styles.getInTouch}>
          <h1 className={styles.head}>Get In Touch</h1>
          {/* <br /> */}
          <p className={styles.det}>
            Get in touch with us. We normally respond within the hour.
          </p>
          <div className={styles.details}>
            {details.map((value, index) => (
              <div className={styles.getInCont} key={index}>
                <div className={styles.icons}>{value.icon}</div>
                <div className={styles.dataCont}>
                  <p className={styles.innerName}>{value.name}</p>
                  <p className={styles.innertData}>{value.data}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.contactUs}>
          <h1 className={styles.head}>Contact Us</h1>
          <br />
          <br />
          <label className={styles.label}>
            Name
          </label>
          <br />
          <input className={styles.input} placeholder="Enter Your Name" type="text" />
          <br />
          <label className={styles.label}>
            Email
          </label>
          <br />
          <input className={styles.input} placeholder="Enter Your Email" type="email" />
          <br />
          <label className={styles.label}>
            Message
          </label>
          <br />
          <textarea className={styles.inputMessage} placeholder="Enter Your Message" type="text" />
          <button className={styles.send}>Send</button>
        </div>
      </div>
      <HomeBottomLast />
    </div>
  );
}
